























































































import {
  Component, Prop, PropSync, Vue, Watch, 
} from 'vue-property-decorator';
import PxDropdown from '@/views/components/input/formFields/PxDropdown.vue';
import PxNumberInput from '@/views/components/input/formFields/PxNumberInput.vue';
import ProbabilisticChart from '@/modules/lcca/views/components/ProbablisticChart.vue';
import { ILccaActivityImperial, ILccaAlternativeImperial } from '@/modules/lcca/interfaces/lccaCalculated';
import { plotActivities } from '@/modules/lcca/lib/alternativeChart';
import ActivityContainer from '@/modules/lcca/views/components/ActivityContainer.vue';
import ActivityEditor from '@/modules/lcca/views/components/ActivityEditor.vue';
import AgencyCostEditor from '@/modules/lcca/views/components/AgencyCostEditor.vue';
import { createNewActivity } from '@/modules/lcca/lib/createNew';


@Component({
  components: {
    AgencyCostEditor,
    ActivityEditor,
    ActivityContainer,
     ProbabilisticChart,
    PxDropdown,
    PxNumberInput,
  },
})
export default class AlternativeContainer extends Vue {
  // @Prop() id!: number;
  @Prop() analysisPeriodLengthYrs!: number;

  @Prop() analysisPeriodStartYr!: number;

  @PropSync('alternative') alt!: ILccaAlternativeImperial;

  @PropSync('allAlternatives') alternatives!: ILccaAlternativeImperial[];

  sync() {
    this.$emit('input');
    this.createChart();
  }

  get id() {
    return this.alt.index;
  }

  get altBaseId() {
    return `alt_${this.id}`;
  }

  activityToEdit: ILccaActivityImperial | null= null;

  editActivity(activityIndex: number) {
    console.log(activityIndex);
    this.activityToEdit = this.alt.activities.filter((A) => A.index === activityIndex)[0];

    this.$bvModal.show(`${this.altBaseId}_modal`);
  }

  createActivity() {
    console.log(this.alt.activities.map((A) => A.index));
    this.alt.activities.push(
      createNewActivity(this.alt.activities.map((A) => A.index).reduce((a, b) => Math.max(a, b)), this.alt.index),
    );
  }

  activityMounted(index: number) {
    /*

    Trigger initial render of chart after all activities have loaded to ensure it only renders once
    on first page load.

    */
    const lastIndex = this.alt.activities.slice(-1)[0].index;

    if (index === lastIndex) {
      this.sync();
    }
  }

  copy() {
    /*
    Create a copy of this alternative and store it in the scenario master list
     */
    console.log('Copying', this.id);

    // Deep copy the alternative
    const newAlt = JSON.parse(JSON.stringify(this.alt));

    newAlt.id = null;

    // Generate an ID
    const highestIdValue = Math.max(...this.alternatives.map((a) => a.index));
    newAlt.index = highestIdValue + 1;

    // Generate a name for the copy
    let newName = `${newAlt.name} Copy`;

    // If newName already exists then:
    // Iterate through counter values until we have a number that doesn't exist
    let c = 0;
    while (this.alternatives.filter((a) => a.name === newName).length > 0) {
      c += 1;
      newName = `${newAlt.name} Copy ${c.toString()}`;
    }

    newAlt.name = newName;

    this.alternatives.push(newAlt);
    this.$emit('copy');
  }

  deleteAlt() {
    this.alternatives = this.alternatives.filter((a) => a !== this.alt);
  }

  editHeader = false;


  toggleEditHeader() {
    this.editHeader = !this.editHeader;
  }

  createChart() {
    plotActivities(this.alt, this.analysisPeriodLengthYrs, this.analysisPeriodStartYr);
  }

  mounted() {
    console.log('Alternative mounted', this.alt.index);
    this.createChart();
  }
}
